import { useState } from "react"

export const Instructions = () => {
    const [showInstructions, setShowInstructions] = useState(false)

    return (
        <div className="mb-4">
            <button
                onClick={() => setShowInstructions(!showInstructions)}
                className="flex items-center justify-between w-full p-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors border border-gray-200"
            >
                <h3 className="text-xl font-bold text-gray-800">
                    🚀 Como usar? (Processo Simplificado)
                </h3>
                <svg
                    className={`w-5 h-5 text-gray-600 transition-transform duration-300 ${
                        showInstructions ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                    />
                </svg>
            </button>

            {/* Conteúdo colapsável */}
            <div
                className={`mt-3 overflow-hidden transition-all duration-300 ${
                    showInstructions
                        ? "max-h-96 opacity-100"
                        : "max-h-0 opacity-0"
                }`}
            >
                <div className="space-y-4 text-gray-600 p-4 bg-blue-50 rounded-lg border border-blue-200">
                    <div className="flex items-start">
                        <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm font-bold px-3 py-1 rounded-full mr-3 mt-0.5">
                            1
                        </div>
                        <div>
                            <p className="font-medium text-gray-800">
                                Prepare seus dados
                            </p>
                            <p className="text-sm">
                                Cole o número da nota e série separados por
                                vírgula
                            </p>
                        </div>
                    </div>
                    <div className="flex items-start">
                        <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm font-bold px-3 py-1 rounded-full mr-3 mt-0.5">
                            2
                        </div>
                        <div>
                            <p className="font-medium text-gray-800">
                                Escolha o formato
                            </p>
                            <p className="text-sm">
                                Selecione entre resumo ou detalhado
                            </p>
                        </div>
                    </div>
                    <div className="flex items-start">
                        <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm font-bold px-3 py-1 rounded-full mr-3 mt-0.5">
                            3
                        </div>
                        <div>
                            <p className="font-medium text-gray-800">
                                Processe em massa
                            </p>
                            <p className="text-sm">
                                Clique em &quot;Processar&quot; e aguarde alguns
                                segundos
                            </p>
                        </div>
                    </div>
                    <div className="flex items-start">
                        <div className="bg-gradient-to-r from-green-500 to-green-600 text-white text-sm font-bold px-3 py-1 rounded-full mr-3 mt-0.5">
                            ✓
                        </div>
                        <div>
                            <p className="font-medium text-green-700">
                                Receba seu relatório
                            </p>
                            <p className="text-sm">
                                Arquivo Excel baixado automaticamente e pronto
                                para análise
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
